import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        checkboxCard: {
            marginBottom: 15,
            [theme.breakpoints.down('sm')]: {
                padding: '16px 12px'
            }
        },
        cardPrimaryInfoWrapper: {
            display: 'flex',
            flexDirection: 'column',
            marginRight: 12,
            [theme.breakpoints.up('md')]: {
                marginRight: 85
            },
            [theme.breakpoints.up('sm')]: {
                marginRight: 45
            }
        },
        cardNumberWrapper: {
            display: 'flex',
            alignItems: 'center',
            minWidth: 111,
            [theme.breakpoints.up('sm')]: {
                minWidth: 115
            }
        },
        cardNumber: {
            fontWeight: 500,
            paddingLeft: 10
        },
        defaultBadge: {
            fontSize: 14,
            lineHeight: 1.43,
            color: '#5E8677',
            borderRadius: 30,
            padding: '3.5px 11px',
            display: 'block',
            backgroundColor: '#E9F0ED'
        },
        primaryBadgeWrapper: {
            display: 'flex',
            width: '100%',
            marginTop: 5,
            [theme.breakpoints.down('md')]: {
                paddingBottom: 8
            }
        },
        primaryBadge: {
            backgroundColor: '#5E8677',
            color: '#FFF'
        },
        expired: {
            backgroundColor: '#EF4F57',
            color: '#fff',
            fontSize: 12,
            borderRadius: 30,
            padding: '4px 8px',
            fontWeight: 500,
            lineHeight: 1,
            marginLeft: 8,
            position: 'relative',
            top: -1,
            [theme.breakpoints.up('md')]: {
                fontSize: 14
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: 10,
                top: 1
            },
            [theme.breakpoints.down(375)]: {
                '& svg': {
                    display: 'none'
                }
            }
        },
        cardExpirationWrapper: {
            display: 'flex',
            alignItems: 'flex-start'
        },
        cardExpirationText: {
            fontSize: 16,
            fontWeight: 500
        }
    })
);
